// extracted by css-extract-rspack-plugin
export default {"numberInputContainer":"numberInputContainer-BHPmC"};